import { ENUM_LABELS, type RequisitionRow, formatPersonName } from '#shared/types';
import { Badge } from '#client/components/ui/Badge';
import type { Column } from '#client/components/ui/DataTable';
import { formatDate, countOf } from '#client/lib/format';
import { TONES } from './requisition-actions';

/**
 * The reagent-order list.
 *
 * At module scope, like every other column array in the app, so it is not
 * reallocated on every render.
 */
export const requisitionColumns: Column<RequisitionRow>[] = [
  {
    key: 'number',
    header: 'Reference',
    frozen: true,
    width: '13rem',
    render: (row) => (
      <div>
        <strong className="c-requisition__number">{row.number}</strong>
        <div className="c-muted">{countOf(row._count.lines, 'reagent')}</div>
      </div>
    ),
  },
  {
    key: 'status',
    header: 'Status',
    width: '11rem',
    render: (row) => (
      <Badge tone={TONES[row.status]}>{ENUM_LABELS.requisitionStatus[row.status]}</Badge>
    ),
  },
  {
    key: 'supplier',
    header: 'Supplier',
    render: (row) => row.supplier?.name ?? <span className="c-muted">Not chosen</span>,
  },
  {
    key: 'department',
    header: 'Bench',
    render: (row) => row.department?.name ?? <span className="c-muted">—</span>,
  },
  {
    key: 'by',
    header: 'Raised by',
    width: '10rem',
    render: (row) => formatPersonName(row.requested_by),
  },
  {
    key: 'expected',
    header: 'Expected',
    width: '9rem',
    render: (row) =>
      row.expected_at ? formatDate(row.expected_at) : <span className="c-muted">—</span>,
  },
  {
    key: 'raised',
    header: 'Raised',
    width: '9rem',
    render: (row) => formatDate(row.created_at),
  },
];
